import React from "react";
import "./Footer.scss";
import logoIUH from "../../resource/img/Logo_IUH.png";

const Footer = () => {
  return (
    <footer className="admin-app-footer py-4 bg-dark text-light border-top">
      <div className="container">
        <div className="row g-4 align-items-center justify-content-between">
          <div className="col-12 col-md-6 text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-3 mb-2">
              <img src={logoIUH} alt="IUH Logo" style={{ height: "36px", objectFit: "contain", filter: "brightness(0) invert(1)" }} />
              <span className="fw-bold fs-5 text-white">IUH Parking Admin Portal</span>
            </div>
            <p className="text-secondary small mb-0">
              Trường Đại học Công nghiệp TP.HCM — 12 Nguyễn Văn Bảo, Phường Hạnh Thông, TP. Hồ Chí Minh
            </p>
          </div>

          <div className="col-12 col-md-6 text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3 small text-secondary mb-2">
              <span><i className="bi bi-telephone-fill me-1 text-primary"></i> 0283.8940 390 - ext 838</span>
              <span><i className="bi bi-envelope-fill me-1 text-primary"></i> csm@iuh.edu.vn</span>
            </div>
            <p className="text-secondary small mb-0">
              © {new Date().getFullYear()} IUH Parking. Phát triển bởi Trung tâm Quản trị Hệ thống. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
